import useCurrency from '@hooks/item/useCurrency';
import { CreateOrderRequest } from '@models/order';
import { orderCheckoutToGtmFormat, pushEcommerceEvent } from '@utils/gtm';
import { getTempOrder } from '@utils/restoreOrderUtils';

interface FailReason {
    fail_code?: string;
    fail_message?: string;
}

/**
 * 상품 주문 결제 실패 시 payment_fail 이벤트를 발화한다.
 * order 를 넘기지 않으면 결제 전 저장한 임시 주문(tempOrder)을 사용한다.
 * 임시 주문을 삭제하기 전에 호출해야 한다.
 */
function useOrderPaymentFail() {
    const currency = useCurrency();

    return async (reason: FailReason, order?: CreateOrderRequest) => {
        try {
            const failedOrder = order || await getTempOrder('ORDER');
            pushEcommerceEvent('payment_fail', {
                purchase_type: 'ORDER',
                currency,
                ...(failedOrder && orderCheckoutToGtmFormat({ order: failedOrder, currency })),
                ...reason,
            });
        } catch (e) {
            console.error(e);
        }
    };
}

export default useOrderPaymentFail;
